import classnames from 'classnames/bind'
import React from 'react'

import Link from '~/components/Link'

import useLocale from '~/hooks/useLocale'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface PaginationProps {
  className?: string
  first?: number
  current?: number
  last?: number
  href?: string
}

function Pagination({
  className,
  first,
  current,
  last,
  href,
}: PaginationProps) {
  const locale = useLocale()

  return (
    <div className={cx(css.Pagination, className)}>
      {current !== first && (
        <>
          <Link
            className={css.link}
            href={href.replace('[page]', first.toString())}
            locale={locale}>
            {first}
          </Link>
          {current - 2 !== first && <span className={css.dots}>...</span>}
        </>
      )}
      {current !== first && current - 1 !== first && (
        <Link
          className={css.link}
          href={href.replace('[page]', (current - 1).toString())}
          locale={locale}>
          {current - 1}
        </Link>
      )}
      <Link
        className={cx(css.link, { active: true })}
        href={href.replace('[page]', current.toString())}
        locale={locale}>
        {current}
      </Link>
      {current !== last && current + 1 !== last && (
        <Link
          className={css.link}
          href={href.replace('[page]', (current + 1).toString())}
          locale={locale}>
          {current + 1}
        </Link>
      )}
      {current !== last && (
        <>
          {current + 2 !== last && <span className={css.dots}>...</span>}
          <Link
            className={css.link}
            href={href.replace('[page]', last.toString())}
            locale={locale}>
            {last}
          </Link>
        </>
      )}
    </div>
  )
}

Pagination.defaultProps = {}

export default Pagination
